import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './styles/CompareWords.css';
import { FaExchangeAlt } from 'react-icons/fa';
import { FaPlus } from 'react-icons/fa';
import axios from 'axios';
import { API_URL } from './config';

const CompareWords = () => {
  const [word1, setWord1] = useState('');
  const [word2, setWord2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState('');
  const [addStatus1, setAddStatus1] = useState('');
  const [addStatus2, setAddStatus2] = useState('');

  const canCompare = word1.trim().length > 0 && word2.trim().length > 0 && !loading;

  const handleSwap = () => {
    setWord1(word2);
    setWord2(word1);
  };

  const handleCompare = async () => {
    if (!canCompare) return;
    setLoading(true);
    setError('');
    setResult('');
    try {
      const response = await axios.post(`${API_URL}/assistant/compare`, {
        word1: word1.trim(),
        word2: word2.trim()
      });
      setResult(typeof response.data.result === 'string' ? response.data.result : '');
    } catch (e) {
      setError('Có lỗi xảy ra. Vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  };

  const addWordToVocabulary = async (word, setStatus) => {
    const target = (word || '').trim();
    if (!target) return;
    setStatus('loading');
    try {
      const res = await axios.post(
        `${API_URL}/search`,
        { word: target },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-model': 'google',
          },
        }
      );

      // Trích JSON trong khối ```json ... ```
      const jsonMatch = res.data?.result?.match(/```json\n([\s\S]*)\n```/);
      if (!jsonMatch) throw new Error('Invalid response format');
      const parsed = JSON.parse(jsonMatch[1]);

      const payload = {
        word: parsed.word || target,
        meaning: parsed.meaning || '',
        kanji: parsed.kanji || '',
        usage: parsed.usage || '',
        example: Array.isArray(parsed.example)
          ? parsed.example.map((ex) => ex.trim()).join('\n\n')
          : parsed.example ? String(parsed.example).trim() : '',
        tips: parsed.tips || '',
      };

      await axios.post(
        `${API_URL}/add`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );

      setStatus('success');
      setTimeout(() => setStatus(''), 3000);
    } catch (e) {
      console.error('Add flow error:', e);
      setStatus('error');
      setTimeout(() => setStatus(''), 4000);
    }
  };

  return (
    <div className="compare-container">
      <div className="compare-grid">
        {/* Panel nhập và hành động */}
        <div className="compare-card input-card">
          <div className="compare-header">
            <h2>So sánh từ vựng</h2>
            <p>Nhập hai từ tiếng Nhật để so sánh sắc thái và cách dùng.</p>
          </div>

          <div className="compare-inputs">
            <div className="input-group">
              <label>Từ 1</label>
              <div className="input-with-action">
                <input
                  type="text"
                  placeholder="VD: 使う"
                  value={word1}
                  onChange={(e) => setWord1(e.target.value)}
                />
                <button
                  type="button"
                  className={`add-icon-btn ${addStatus1 === 'loading' ? 'loading' : ''}`}
                  onClick={() => addWordToVocabulary(word1, setAddStatus1)}
                  title="Add từ 1 vào danh sách"
                >
                  <FaPlus />
                </button>
              </div>
              {addStatus1 && (
                <div className={`inline-status ${addStatus1}`}>
                  {addStatus1 === 'loading' ? 'Đang thêm…' : addStatus1 === 'success' ? 'Đã thêm' : addStatus1 === 'error' ? 'Lỗi' : ''}
                </div>
              )}
            </div>

            <button className="swap-btn" title="Đổi chỗ" onClick={handleSwap} type="button">
              <FaExchangeAlt />
            </button>

            <div className="input-group">
              <label>Từ 2</label>
              <div className="input-with-action">
                <input
                  type="text"
                  placeholder="VD: 用いる"
                  value={word2}
                  onChange={(e) => setWord2(e.target.value)}
                />
                <button
                  type="button"
                  className={`add-icon-btn ${addStatus2 === 'loading' ? 'loading' : ''}`}
                  onClick={() => addWordToVocabulary(word2, setAddStatus2)}
                  title="Add từ 2 vào danh sách"
                >
                  <FaPlus />
                </button>
              </div>
              {addStatus2 && (
                <div className={`inline-status ${addStatus2}`}>
                  {addStatus2 === 'loading' ? 'Đang thêm…' : addStatus2 === 'success' ? 'Đã thêm' : addStatus2 === 'error' ? 'Lỗi' : ''}
                </div>
              )}
            </div>
          </div>

          <div className="actions">
            <button
              className={`compare-btn ${canCompare ? '' : 'disabled'}`}
              onClick={handleCompare}
              disabled={!canCompare}
              type="button"
            >
              {loading ? 'Đang kiểm tra...' : 'So sánh'}
            </button>
          </div>

          {error && <div className="error-box">{error}</div>}
        </div>

        {/* Panel kết quả riêng, có cuộn bên trong */}
        <div className="compare-card result-card">
          <div className="result-panel">
            <div className="result-header">Kết quả</div>
            <div className="result-scroll">
              <div className="result-content">
                {result ? (
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>{result}</ReactMarkdown>
                ) : (
                  <div className="placeholder">Kết quả sẽ hiển thị tại đây dưới dạng Markdown.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompareWords;


